import request_index from "../index";
import { getUsessionId } from '@/utils-khfw/usession.service.js';
async function request(params) {
    let uid = await getUsessionId();
    if (params.data) {
        params.data = {
            ...params.data,
            loginPlatformCode: sessionStorage.getItem("loginPlatformCode"),
            platformCode: sessionStorage.getItem("platformCode"),
            usessionid: uid,
        }
    }
    return request_index(params);
};
/* 学校端-接口 */
const schoolApi = {
    /******************* 课程接口 **********************************/
    // 全部课程列表
    getSchoolCourseALLList(data) {
        return request({
            url: `/assbe/course/school/alllist`,
            method: "post",
            data,
        })
    },
    // 自建课程列表
    getSchoolCourseSelfList(data) {
        return request({
            url: `/assbe/course/school/ownlist`,
            method: "post",
            data,
        })
    },
    // 新增课程
    addCurriculum(data) {
        return request({
            url: '/assbe/course/institution/add',
            method: "post",
            data,
        });
    },
    // 引入课程列表
    getSchoolCourseImportList(data) {
        return request({
            url: `/assbe/course/school/importlist`,
            method: "post",
            data,
        })
    },
    // 新增试课
    schoolCourseApply(data) {
        return request({
            url: `/assbe/course/school/apply`,
            method: "post",
            data,
        })
    },
    // 取消试课
    schoolCourseCancel(data) {
        return request({
            url: `/assbe/course/school/cancel`,
            method: "post",
            data,
        })
    },
    // 引入课程
    schoolCourseImportcourse(data) {
        return request({
            url: `/assbe/course/school/importcourse`,
            method: "post",
            data,
        })
    },
    // 取消引入课程
    schoolCourseCancelcourse(data) {
        return request({
            url: `/assbe/course/school/cancelcourse`,
            method: "post",
            data,
        })
    },
    // 加入校本选课
    schoolCourseJoincourse(data) {
        return request({
            url: `/assbe/course/school/joincourse`,
            method: "post",
            data,
        })
    },
    // 取消加入校本选课
    schoolCourseRemovecourse(data) {
        return request({
            url: `/assbe/course/school/removecourse`,
            method: "post",
            data,
        })
    },

    /************* 服务管理 ****************/
    // 课程评价列表
    schoolCourseEvaluateList(data) {
        return request({
            url: `/assbe/courseevaluate/authority/list`,
            method: "post",
            data,
        })
    },
    // 课程评价-通过
    schoolCourseEvaluatePass(data) {
        return request({
            url: `/assbe/courseevaluate/authority/audit/pass`,
            method: "post",
            data,
        })
    },
    // 课程评价-不通过
    schoolCourseEvaluateFailed(data) {
        return request({
            url: `/assbe/courseevaluate/authority/audit/failed`,
            method: "post",
            data,
        })
    },

    /************* 统计分析 ****************/
    // 查询学校课程评价各星级数据
    schoolStatisticalStar(data) {
        return request({
            url: `/assbe/courseevaluate/statistical/star`,
            method: "post",
            data,
        })
    },
    // 获取平台学期学年信息
    schoolStatisticalSemester(data) {
        return request({
            url: `/assbe/courseevaluate/statistical/semester`,
            method: "post",
            data,
        })
    },
    // 机构课程评价统计
    schoolStatisticalOrgstar(data) {
        return request({
            url: `/assbe/courseevaluate/statistical/orgstar`,
            method: "post",
            data,
        })
    },
    // 查询机构课程评价列表
    schoolStatisticalOrgCourse(data) {
        return request({
            url: `/assbe/courseevaluate/statistical/orgcourse`,
            method: "post",
            data,
        })
    },
    // 评价删除
    schoolStatisticalDelete(data) {
        return request({
            url: `/assbe/courseevaluate/statistical/delete`,
            method: "post",
            data,
        })
    },
    /************* 系统课程库 ****************/
    // 系统课程库列表
    handleSystemList(data) {
        return request({
            url: `/assbe/course/system/list`,
            method: "post",
            data,
        })
    },
    // 课程引入 
    handleSystemIntroduce(data) {
        return request({
            url: `/assbe/course/system/introduce`,
            method: "post",
            data,
        })
    },
}

export default schoolApi;